/**
 * 本地转换，逐个转换，建议使用，速度比向百度请求快多了
 *
 */
const pi = 3.14159265358979324;      //圆周率
const ee = 0.00669342162296594323;   //椭球的偏心率
const a = 6378245.0;                 //卫星椭球坐标投影到平面地图坐标系的投影因子
const x_pi = 3.14159265358979324 * 3000.0 / 180.0;  //圆周率转换量
// 求弧度
export function radian(d) {
    return d * pi / 180.0;   //角度1? = π / 180
}

export function transformLat(lat, lon)    //纬度转化
{
    let ret = -100.0 + 2.0 * lat + 3.0 * lon + 0.2 * lon * lon + 0.1 * lat * lon + 0.2 * Math.sqrt(Math.abs(lat));
    ret += (20.0 * Math.sin(6.0 * lat * pi) + 20.0 * Math.sin(2.0 * lat * pi)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lon * pi) + 40.0 * Math.sin(lon / 3.0 * pi)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(lon / 12.0 * pi) + 320 * Math.sin(lon * pi / 30.0)) * 2.0 / 3.0;
    return ret;
}

export function transformLon(lat, lon)   //经度转化
{
    let ret = 300.0 + lat + 2.0 * lon + 0.1 * lat * lat + 0.1 * lat * lon + 0.1 * Math.sqrt(Math.abs(lat));
    ret += (20.0 * Math.sin(6.0 * lat * pi) + 20.0 * Math.sin(2.0 * lat * pi)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lat * pi) + 40.0 * Math.sin(lat / 3.0 * pi)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(lat / 12.0 * pi) + 300.0 * Math.sin(lat / 30.0 * pi)) * 2.0 / 3.0;
    return ret;
}

/*****************************************************************************
 * WGS84(GPS坐标系) to 火星坐标系(GCJ-02)
 *
 * @param lat
 * @param lon
 * @return
 ****************************************************************************/
export function GPS84_To_GCJ02(WGS84_Lat, WGS84_Lon) {
    let dLat;
    let dLon;
    let radLat;
    let magic;
    let sqrtMagic;
    dLat = transformLat(WGS84_Lon - 105.0, WGS84_Lat - 35.0);
    dLon = transformLon(WGS84_Lon - 105.0, WGS84_Lat - 35.0);
    radLat = WGS84_Lat / 180.0 * pi;
    magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    sqrtMagic = Math.sqrt(magic);
    dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * pi);
    dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * pi);
    let GCJ02_Lat = parseFloat(WGS84_Lat) + parseFloat(dLat);    //GCJ02_Lat是百度纬度存储变量的地址  *GCJ02_Lat就是那个值
    let GCJ02_Lon = parseFloat(WGS84_Lon) + parseFloat(dLon);    //GCJ02_Lon是百度经度存储变量的地址  *GCJ02_Lon
    return [GCJ02_Lat, GCJ02_Lon]
}

/*****************************************
 * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换算法 将 GCJ-02 坐标转换成 BD-09 坐标
 *
 * @param gg_lat
 * @param gg_lon
 *****************************************/
//传入的参数  	GCJ02_To_BD09(*BD09_Lat,*BD09_Lon,BD09_Lat,BD09_Lon);
//(*BD09_Lat,*BD09_Lon)火星坐标,(BD09_Lat,BD09_Lon)是变量的地址
export function GCJ02_To_BD09(GCJ02_Lat, GCJ02_Lon) {
    let x = GCJ02_Lon, y = GCJ02_Lat;
    let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
    let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
    let BD_09_Lon = z * Math.cos(theta) + 0.0065;
    let BD_09_Lat = z * Math.sin(theta) + 0.006;
    return [BD_09_Lon, BD_09_Lat]
}

/*************************************************************
 函数名称：GPS_transformation(double WGS84_Lat, double WGS84_Lon,double * BD_09_Lat, double * BD_09_Lon)
 函数功能：GPS坐标转百度地图坐标
 输入参数：WGS84_Lat,WGS84_Lon GPS获取到真实经纬度  储存得到的百度经纬度变量的地址 BD_09_Lat,BD_09_Lon指向那个变量
 输出参数：
 *************************************************************/
export function GPS_transformation(WGS84_Lat, WGS84_Lon) {
    let Gcj02 = GPS84_To_GCJ02(WGS84_Lat, WGS84_Lon);//GPS坐标转火星坐标
    return GCJ02_To_BD09(Gcj02[0], Gcj02[1]); //火星坐标转百度坐标
}

export function rgbToHsb(arr) {
    var h = 0, s = 0, v = 0;
    var r = arr[0], g = arr[1], b = arr[2];
    arr.sort(function (a, b) {
        return a - b;
    })
    var max = arr[2]
    var min = arr[0];
    v = max / 255;
    if (max === 0) {
        s = 0;
    } else {
        s = 1 - (min / max);
    }
    if (max === min) {
        h = 0;//事实上，max===min的时候，h无论为多少都无所谓
    } else if (max === r && g >= b) {
        h = 60 * ((g - b) / (max - min)) + 0;
    } else if (max === r && g < b) {
        h = 60 * ((g - b) / (max - min)) + 360
    } else if (max === g) {
        h = 60 * ((b - r) / (max - min)) + 120
    } else if (max === b) {
        h = 60 * ((r - g) / (max - min)) + 240
    }
    h = parseInt(h);
    s = parseInt(s * 100);
    v = parseInt(v * 100);
    return [h, s, v]
}

export function hsbToRgb(h, s, v) {
    s = s / 100;
    v = v / 100;
    var r = 0, g = 0, b = 0;
    var i = parseInt((h / 60) % 6);
    var f = h / 60 - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    switch (i) {
        case 0:
            r = v;
            g = t;
            b = p;
            break;
        case 1:
            r = q;
            g = v;
            b = p;
            break;
        case 2:
            r = p;
            g = v;
            b = t;
            break;
        case 3:
            r = p;
            g = q;
            b = v;
            break;
        case 4:
            r = t;
            g = p;
            b = v;
            break;
        case 5:
            r = v;
            g = p;
            b = q;
            break;
        default:
            break;
    }
    r = parseInt(r * 255.0)
    g = parseInt(g * 255.0)
    b = parseInt(b * 255.0)
    return `rgb(${r},${g},${b})`
}

export function hexToRgb(hex) {
    let sColor = hex.toLowerCase()
    let sColorChange = []
    for (let i = 1; i < 7; i += 2) {
        sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
    }
    return sColorChange
}

export function rgbToHex(rgb){
    var aColor = rgb.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
    var strHex = "#";
    for (var i=0; i<aColor.length; i++) {
        var hex = Math.round(Number(aColor[i])).toString(16);
        if (hex.length < 2) {
            hex = '0' + hex;
        }
        strHex += hex;
    }
    return strHex

}



// WEBPACK FOOTER //
// ./src/utils/gpsToBD.js